"use client";

import cookiePic from "../assets/cookie-pic.svg";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import {
  notificationTransition,
  notificationVariants,
} from "./utils.animation";

export const CookieNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasConsented, setHasConsented] = useState(false);

  useEffect(() => {
    const accepted = document.cookie.includes("CookieConsent=true");
    if (!accepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    document.cookie =
      "CookieConsent=true; path=/; max-age=" + 60 * 60 * 24 * 150;
    setHasConsented(true);
    setTimeout(() => setIsVisible(false), 1100);
  };

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      {!hasConsented && (
        <motion.div
          className="cookie-notification"
          initial="initial"
          animate="in"
          exit="exit"
          variants={notificationVariants}
          transition={notificationTransition}
        >
          <div className="cookie-notification__inner">
            <div className="cookie-notification__text">
              <img
                src={cookiePic}
                alt="Cookie icon"
                className="cookie-notification__icon"
              />
              Используя данный сайт, вы даете согласие на использование файлов
              cookie, помогающих сделать его удобнее для вас.
            </div>

            <div className="cookie-notification__actions">
              <button
                onClick={handleAccept}
                className="cookie-notification__button"
              >
                Принять и закрыть
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

